// ------------------------------------
// props 輸入需求 : 
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            (  )
// ------------------------------------

import React, { useState, useEffect, useContext } from 'react'
import '../historyRecord/_HistoryRecord.scss'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const DownloadHis =(props)=>{
    const {t} = useTranslation()
    // 先配對 bed id 和 residents
    const [page, setPage] = useState();
    // 日期
    const timestamp_now = new Date().getTime()

    // ------------------ redux ------------------
    const store = useSelector(state=>state.store_hisPage)
    const dispatch = useDispatch()
    useEffect(()=>{
        
    }, [])
    // ------------------ redux ------------------
   
    return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-d-c fx-ccc bg-black" onClick={props.hide}>
            <div className={`layout-history rotateAll fx-d-c`} onClick={e=>e.stopPropagation()}>
                <div className="h-15 fx-d-r font-m">
                <div className="w-40 fx-d-c fx-ccc">
                    <div className="w-90 font-xl fx-fsc">下載每日報表</div>
                    <div className="w-90 font-m fx-fsc">{}</div>
                </div>
                <div className='w-45'></div>
                {/* close btn */}
                <div className="fx-2 fx-nfen" onClick={props.hide}>
                    <div className="cross dark fx-ccc cursor pt"></div>
                </div>
                {/* close btn */}
            </div>
                <div className="h-85 fx-d-c w-100">
                    {page}  
                </div>
            </div>
        </div>
    );	

}
export default DownloadHis;